import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AdminUserDetailForm } from './AdminUserDetailForm';
import { Button } from '@/components/ui';
import type { User } from '@/lib/types/core';

type Props = {
  currentUser: Pick<User, 'id' | 'roles' | 'is_active'> | null;
  users: Pick<User, 'id' | 'name' | 'email' | 'telegram_username' | 'beem_id' | 'is_active' | 'roles' | 'eft_account_name' | 'eft_bsb' | 'eft_account_number' | 'auto_add_to_game'>[];
};

export function AdminUserDetailPage({ currentUser, users }: Props) {
  const { userId } = useParams<{ userId: string }>();
  const navigate = useNavigate();
  const user = users.find((u) => u.id === userId);

  if (!user) {
    return (
      <div className="max-w-md mx-auto py-6 px-4 min-h-screen bg-[#f5f7f8]">
        <div className="bg-white rounded-2xl p-6 text-center">
          <h1 className="text-lg font-black mb-2">User not found</h1>
          <Button onClick={() => navigate('/admin/users')}>Back to Users</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto py-6 px-4 min-h-screen bg-[#f5f7f8]">
      <Button variant="ghost" onClick={() => navigate('/admin/users')} className="mb-4">
        ← Back to Users
      </Button>
      <AdminUserDetailForm currentUser={currentUser} user={user} />
    </div>
  );
}
